import axios from "axios";

export const sendESignKp = (
  kpId: number | undefined,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}send/sign/keyperson`,
      {
        params: {
          //   filter: "[]",
          //   app_id: appId,
          key_person_id: kpId,
          // signed_application_form_status: "Sent for esign",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
